// Rhai's standard-package free functions (Rhai book, "Standard packages"):
// what a script may call by bare name without defining it. Method calls
// (`x.len()`) are never checked, so only names that can appear as a free
// call matter — and Rhai lets any method be called that way with the
// receiver first, so the list leans inclusive: a missed name here is a
// false "Function not found", the worse failure.
export const RHAI_STDLIB_FUNCTIONS: readonly string[] = [
  // core / misc
  "print",
  "debug",
  "type_of",
  "sleep",
  "timestamp",
  "elapsed",
  "range",
  "eval",
  "Fn",
  "call",
  "curry",
  "is_shared",
  "is_def_fn",
  "is_def_var",
  "is_anonymous",
  "min",
  "max",
  // numbers
  "abs",
  "sign",
  "sqrt",
  "exp",
  "ln",
  "log",
  "sin",
  "cos",
  "tan",
  "asin",
  "acos",
  "atan",
  "sinh",
  "cosh",
  "tanh",
  "hypot",
  "floor",
  "ceiling",
  "round",
  "int",
  "fraction",
  "is_zero",
  "is_odd",
  "is_even",
  "is_nan",
  "is_finite",
  "is_infinite",
  "to_degrees",
  "to_radians",
  "parse_int",
  "parse_float",
  "parse_json",
  "to_json",
  "to_int",
  "to_float",
  "to_decimal",
  "to_string",
  "to_debug",
  // strings
  "to_upper",
  "to_lower",
  "make_upper",
  "make_lower",
  "trim",
  "len",
  "chars",
  "contains",
  "starts_with",
  "ends_with",
  "index_of",
  "sub_string",
  "split",
  "split_rev",
  "replace",
  "crop",
  "clear",
  "truncate",
  "pad",
  "append",
  "remove",
  "get",
  "set",
  "is_empty",
  "bytes",
  "to_blob",
  "to_chars",
  // arrays
  "push",
  "pop",
  "shift",
  "insert",
  "reverse",
  "drain",
  "retain",
  "splice",
  "extract",
  "sort",
  "dedup",
  "map",
  "filter",
  "reduce",
  "reduce_rev",
  "some",
  "all",
  "for_each",
  "find",
  "find_map",
  "chop",
  "zip",
  // maps
  "keys",
  "values",
  "mixin",
  "fill_with",
  "to_array",
];
